<template>
  <div>
    <MainMenu
      class="scf-main-menu"
      author="Sergi Colomer Ferrer"
    />

    <Transition name="fade">
      <HomePage
        v-if="$store.state.targetComponent === 'home'"
        class="scf-home-page"
      />
    </Transition>

    <Transition name="fade">
      <AllProjects
        v-if="$store.state.targetComponent === 'programming'"
        class="scf-all-projects"
        :projects="$store.getters.getProjectsType('programming')"
        :highlightProjects="$store.getters.getHighlightProjectsType('programming')"
      />
    </Transition>

    <Transition name="fade">
      <AllProjects
        v-if="$store.state.targetComponent === 'design'"
        class="scf-all-projects"
        :projects="$store.getters.getProjectsType('design')"
        :highlightProjects="$store.getters.getHighlightProjectsType('design')"
      />
    </Transition>

    <Transition name="fade">
      <AboutMe
        v-if="$store.state.targetComponent === 'about me'"
        class="scf-about-me"
      />
    </Transition>

    <Transition name="fade">
      <ProjectDetail
        v-if="$store.state.targetComponent === 'detailProject'"
        class="scf-project-detail"
        :project="$store.getters.getSelectedProject"
      />
    </Transition>

    <FooterBlock class="scf-footer-block" />

    <OverlayPicture
      v-if="$store.state.overlayPicture.images.length !== 0"
      class="scf-overlay-picture-block"
    />

    <form id="easter-egg-form">
      <button
        id="easter-egg"
        type="button"
        @click="easterEgg($store)"
      ></button>
    </form>
  </div>
</template>

<script>
import MainMenu from "./components/MainMenu.vue";
import HomePage from "./components/HomePage.vue";
import AllProjects from "./components/AllProjects.vue";
import AboutMe from "./components/AboutMe.vue";
import ProjectDetail from "./components/ProjectDetail.vue";
import FooterBlock from "./components/FooterBlock.vue";
import OverlayPicture from "./components/OverlayPicture.vue";

export default {
  name: "App",
  components: {
    MainMenu,
    HomePage,
    AllProjects,
    AboutMe,
    ProjectDetail,
    FooterBlock,
    OverlayPicture,
  },
  methods: {
    easterEgg(store) {
      if (store.state.easterEgg) {
        document.dispatchEvent(new CustomEvent("easteregg::hide"));
      } else {
        document.dispatchEvent(new CustomEvent("easteregg::show"));
      }
      store.state.easterEgg = !store.state.easterEgg;
    },
  },
};
</script>

<style lang="less" scoped>
.scf-project-detail,
.scf-all-projects,
.scf-about-me {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms ease;
}
.fade-enter-from {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="less">
/* reset styles */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* init portfolio styles */

@import "styles/all.less";
body {
  background-color: @base;
  color: @white-80;
  font-family: "Fira Mono", arial, sans;
  font-size: inherit;
  line-height: 1.4em;
}
#easter-egg-form {
  position: fixed;
  bottom: @scf-space-s; // 16px
  right: @scf-space-sm; // 20px
  z-index: @max-z-index-page + 2;

  @media @scf-breakpoints--l {
    bottom: @scf-space-xs; // 12px
    right: @scf-space-s; // 16px
  }
}
#easter-egg {
  border: 1px solid @white-40;
  background-color: @white-20;
  border-radius: 2px;
  opacity: 0.8;
  width: @scf-space-xs; // 12px
  height: @scf-space-xs; // 12px
  margin: 0;
  padding: 0;

  @media @scf-breakpoints--l {
    width: @scf-space-2xs; // 8px
    height: @scf-space-2xs; // 8px
  }

  &:hover {
    border: 1px solid @white;
    background-color: @white-40;
    opacity: 1;
  }
}
</style>
